<template><span class="k-txt-rank" :class="_skin">{{text}}</span></template>

<script>
    // 数字转中文
    // function n2c(value) {
    //     return '一二三四五六七八九十'.split('')[value - 1]
    // }
    export default {
        name: 'k-txt-rank',
        props: ['value', 'color'],
        computed: {
            _skin() {
                return this.color ? this.color : 'red'
            },
            text() {
                const {value} = this
                return value > 0 ? `第${value}名` : value < -10 ? '无效' : `倒数第${-value}名`
            }
        }
    };
</script>
